export enum FilterTypeEnum {
  BuildingUtilization,
  FloorUtilization,
  AreaUtilization,
  BuildingsComparison,
  NewBuildings,
}
